import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "can-parents-help-adult-child-get-depression-treatment",
  title: "Can Parents Help an Adult Child Get Depression Treatment?",
  description:
    "Yes — parents can research treatment options and contact a center on behalf of an adult child. Learn what you can do and where the boundaries of consent are.",
  keywords:
    "parents help adult child depression, call for adult child treatment, family depression treatment, parent involvement",
  badge: "Educational Article",
  heroTitle: "Can Parents Help an Adult Child Get Depression Treatment?",
  heroSubtitle:
    "Yes. You can research treatment options and contact a center on behalf of your adult child. The decision to begin treatment belongs to them — but gathering information is something you can do now.",
  sections: [
    {
      heading: "What You Can Do",
      body: "You can learn about treatment options, contact a center to understand the consultation process, and share what you find with your adult child. Gathering information is a practical, supportive step.",
    },
    {
      heading: "Where the Boundary Is",
      body: "Your adult child must be the one to consent to and participate in treatment. You cannot schedule or authorize treatment on their behalf. But you can be the one who finds the door and holds it open.",
      callout: true,
    },
    {
      heading: "How to Start the Conversation",
      body: "Choose a calm moment, not a crisis. Share what you've learned without pressure. You might say: 'I found a center that offers treatments I hadn't heard of. I'm not asking you to commit — I just want you to know there are other options.'",
    },
    {
      heading: "If They Say No",
      body: "A no today is not permanent. Keep the door open. Sometimes the right moment comes later, and knowing the options exist makes a difference when it does.",
    },
  ],
  faq: [
    {
      question: "Can I schedule treatment for my adult child?",
      answer:
        "A family member can contact us to learn about services and the consultation process. The patient themselves must consent to and participate in treatment.",
    },
    {
      question: "Will my adult child's information be shared with me?",
      answer:
        "Patient privacy is protected. We can discuss general information with family members, but clinical details require the patient's consent.",
    },
  ],
  related: [
    {
      title: "My Adult Child Has Depression",
      href: "/adult-child-with-depression",
    },
    {
      title: "Helping Someone You Love With Depression",
      href: "/helping-someone-with-depression",
    },
    {
      title: "What Happens During a Consultation",
      href: "/depression-treatment-consultation",
    },
  ],
  finalCtaText:
    "You can take the first step on behalf of your adult child. Call our team to understand what options may be available.",
});
